// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__31tUc","imageUploader":"EGiftCard_imageUploader__1oq3C"};